import { isUndefined } from '@aloft/toolkit-shared';

import { Typography } from '../../../summary/components/Typography.tsx';
import { SummarySection } from '../SummarySection.tsx';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';

export const AdjustmentBreakdownDepreciatedCostMainDwellingGLA = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => {
  const { depreciatedCostPerSqFt } = props.results.subject?.features?.mainDwelling ?? {};

  if (isUndefined(depreciatedCostPerSqFt)) {
    return null;
  }

  const glaAdjustmentString = `${depreciatedCostPerSqFt.toString(true)}/sf`;

  return (
    <SummarySection marginBottom="2rem">
      <TitleAndExportToggleLockup
        {...props}
        title="GLA"
        id="isDepreciatedCostMainDwellingGLAInExport"
        variant="h3"
      />
      <Typography variant="body1">
        {`The GLA adjustment of ${glaAdjustmentString} is based on the depreciated cost per
                square foot for a dwelling of the subject’s quality and condition.`}
      </Typography>
    </SummarySection>
  );
};
